import * as types from '../actions';

export default function setEditSeedID(seedID) {
  return {
    type: types.VIEWER_SET_EDIT_SEED_ID,
    seedID,
  };
}
